import { useRef } from 'react';
import { Field } from '@shopify/react-form';
import gettext, { pgettext } from '@sdk/lang/gettext';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { GroupedPersonaPicker } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/GroupedPersonaPicker';

import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import {
  FieldContainer,
  EllipsisContainer,
} from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import PositionIconSvg from '@web/assets/svg/Icons/32/position-gray.svg';

type Props = {
  positionField: Field<PersonaPickerOption[]>;
  options: PersonaPickerOption[];
};
const PositionRow = ({ positionField, options }: Props) => {
  const fieldRef = useRef<HTMLInputElement>(null);
  return (
    <ModalRow label={gettext('Position')} icon={PositionIconSvg}>
      <EllipsisContainer ref={fieldRef} width={fieldRef?.current?.offsetWidth}>
        <FieldContainer>
          <GroupedPersonaPicker
            onSelectedItemsChange={positionField.onChange}
            options={options}
            selectedItems={positionField.value}
            placeholder={pgettext('Always singular', 'Add position')}
            showTagIcons
            showTagSubtitles={false}
            showSearchIcon={false}
            maxItemsToSelect={1}
            hasError={Boolean(positionField.error?.length)}
          />
        </FieldContainer>
      </EllipsisContainer>
    </ModalRow>
  );
};

export default PositionRow;
